/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Tooltip2Inputs */

const en_coinvestments_dataroom_tooltip2 = /** @type {(inputs: Coinvestments_Dataroom_Tooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign the NDA to access the data room`)
};

/**
* | output |
* | --- |
* | "Sign the NDA to access the data room" |
*
* @param {Coinvestments_Dataroom_Tooltip2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_tooltip2 = /** @type {((inputs?: Coinvestments_Dataroom_Tooltip2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Tooltip2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_tooltip2(inputs)
});
export { coinvestments_dataroom_tooltip2 as "coInvestments_dataRoom_tooltip" }